<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          style="color:white;background-color: rgba(0, 0, 0, 0);width:80%"
        >
          <h1>微型企业一站式云服务平台</h1>
          <hr class="my-4">
          <p>帮助微型企业构建在线化、智能化的经营管理体系，让经营管理更轻松</p>
        </b-jumbotron>
      </div>
    </div>
    <div class="title">
      <div style="display:flex;padding-top:100px;padding-bottom:100px">
        <img src="./jdy1.png">
      </div>
    </div>
    <div style="background:">
      <div class="title">
        <div style="display:flex;padding-top:10px;padding-bottom:100px">
          <img src="./jdy2.png">
        </div>
      </div>
    </div>
    <div style="background:#f5f7fa">
      <div class="title">
        <div style="display:flex;padding-top:100px;padding-bottom:100px">
          <img src="./jdy3.png">
        </div>
      </div>
    </div>
    <div style="background:">
      <div class="title">
        <div style="display:flex;padding-top:100px;padding-bottom:100px">
          <img src="./jdy4.png">
        </div>
      </div>
    </div>
    <div style="background:">
      <div class="title">
        <div style="display:flex;flex-direction: column;padding-top:0px;padding-bottom:100px">
          <p style="font-weight:600;font-size:30px">他们都选择了金蝶·精斗云</p>
          <img src="./jdy5.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Cosmic',
  data() {
    return {
      header: '金蝶·精斗云',
      leader: '微型企业一站式云服务平台'
    }
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202112/152125333a9k.png') no-repeat;
  background-size: 100%;
  height: 500px;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
</style>>




// WEBPACK FOOTER //
// src/components/jdy.vue